import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'excludeSelected',
    pure: false,
    standalone: false
})
export class ExcludeSelectedPipe implements PipeTransform {
  transform(allOptions: string[], selectedOptions: string[]): string[] {
    return allOptions.filter(option => !selectedOptions.includes(option));
  }
}
